// extracted by mini-css-extract-plugin
module.exports = {"primary":"_2d1d3b60","attention":"_531ba54b","secondary":"_949762d3","twitter":"_98d0ebb6","facebook":"_47b69daf","text":"_2c10e442"};